export type IMediaAboutUsResources = typeof MediaAboutUsResources;

export const MediaAboutUsResources = {
    mediaArticle1: "goodie - inspiracje, okazje, zakupy - WP Kobieta",
    mediaArticle2: "Gazetki promocyjne, karty lojalnościowe, kupony i cashback w jednej apce",
    mediaArticle3: "Użytkownicy goodie cashback oszczędzili już ponad 12 mln zł - Bank Millennium",
};
